import React, { useEffect, useState } from "react";
import { Form, Input, Button, Rate, Card } from "antd";
import { FrownOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";
import { SurveyItem } from "../../Model/dbo/Survey";
import { GetItemsSurveyPersonels, SendPersonelSurveyItems } from "../../RestAPI/dbo/Morakasiapi";
import { useNavigate } from "react-router-dom";

const Survey: React.FC = () => {
    const [form] = Form.useForm();


    const[questions,SetQuestions]=useState<Array<SurveyItem>>();
    const[showform,setShowForm]=useState(false);


    useEffect(() => {
        fetchData();
      }, []);
    


async function  fetchData() {
    var dt=await GetItemsSurveyPersonels();
    if(dt.length != 0){
        setShowForm(true);
        SetQuestions(dt);
    }
}
const navigate = useNavigate();

    const onFinish = async (values: any) => {
        const resultArray = questions?.map((question) => ({
           ID: question.ID,
            Rate: values[question.ID]
          }));
           
          await SendPersonelSurveyItems(resultArray,values.comment)
         // alert("با تشکر، نظر شما ثبت شد")
          //navigate("/home");
    };

    
  
    return (
        <>
        <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4">
            <Card title="فرم نظرسنجی" className="w-full max-w-2xl shadow-lg rounded-2xl p-6" style={{margin:15,direction:"rtl"}}>
                {showform ?<>
                    <Form form={form} layout="vertical" onFinish={onFinish}>
                    {questions?.map((question, index) => (
                        <Form.Item
                            key={question.ID}
                            label={question.Description}
                            name={question.ID}
                            rules={[{ required: true, message: "لطفا امتیاز دهید" }]}
                        >
                            <Rate style={{ color: "red" , fontSize: "28px"}}   allowHalf/>
                        </Form.Item>
                    ))}

                    <Form.Item label="چنانچه پیشنهاد یا توضیح دیگری دارید میتوانید در قسمت زیر وارد نمایید:" name="comment">
                        <Input.TextArea rows={4} placeholder="نظر خود را وارد کنید..." />
                    </Form.Item>

                    <Form.Item className="text-center">
                        <Button type="primary" htmlType="submit" className="w-full">
                            ثبت نظر سنجی
                        </Button>
                    </Form.Item>
                </Form>
                </>
                :
                <>
                <h3 style={{color:"red"}}>
                    شما در این دوره در نظر سنجی شرکت کرده اید.
                </h3>
                <br></br>
                <p>
                    در صورت تمایل به بخش  <label style={{color:"red",fontSize:15}} >پیشنهاد/انتقاد</label> منوی اصلی مراجعه کنید.
                </p>
                   
                                  </>
                }
                
            </Card>
        </div>

        </>
    );
};

export default Survey;
